export default {
  baseStyle: {
    borderRadius: 'full'
  },
  sizes: {
    xl: {
      fontSize: 'lg',
      px: '6',
      h: '14'
    }
  },
  variants: {
    primary: {
      color: 'GREYSCALE.MOON',
      backgroundColor: 'CARNABY.regular',
      _hover: {
        backgroundColor: 'CARNABY.dark'
      },
      _disabled: {
        color: 'GREYSCALE.NEBULA',
        opacity: 'initial',
        backgroundColor: 'GREYSCALE.CONSTELLATION',
        _hover: {
          backgroundColor: 'GREYSCALE.CONSTELLATION !important'
        }
      }
    },
    secondary: {
      color: 'CARNABY.regular',
      backgroundColor: 'CARNABY.extraLight',
      borderColor: 'CARNABY.regular',
      border: '1px',
      _hover: {
        backgroundColor: 'CARNABY.light'
      }
    }
  }
};